/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { logKeropen } from "./src/lib/keropen-art"

// DevTools のコンソールを開いたとき、公式キャラ「信頼けろぺん」を表示する
// アート本体は projects/img2ascii で公式SVGから自動生成（src/keropen-art.js）
export const onClientEntry = () => {
  logKeropen()
  console.log(
    "%c信頼けろぺん  %c×  %cSRE NEXT 2027",
    "color:#33b495; font-weight:bold; font-size:16px;",
    "color:#777; font-size:14px;",
    "color:#3781bc; font-weight:bold; font-size:16px;",
  )
  console.log(
    "%c見つかっちゃった！！",
    "color:#f8c164; font-size:12px;",
  )
}
